import { render, staticRenderFns } from "./aktionen-renderer.vue?vue&type=template&id=83b6444a&scoped=true"
import script from "./aktionen-renderer.vue?vue&type=script&lang=js"
export * from "./aktionen-renderer.vue?vue&type=script&lang=js"
import style0 from "./aktionen-renderer.vue?vue&type=style&index=0&id=83b6444a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b6444a",
  null
  
)

export default component.exports